<template>
<section id="entry-form" class="bgLGray">
  <form>
    <p class="entry-form-info" v-html="$t('CONTACT_FORM_INFO_TEXT')"></p>
    <table class="tbl-entry">
      <tbody>
        <tr>
          <th>ID</th>
          <td>
            {{parent.memberId ? parent.memberId : $t('CONTACT_FORM_GUEST_TEXT')}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_NICKNAME_LABEL')"></th>
          <td>
            <input type="text" class="iptW-M" required v-model="parent.contactData.nickname" v-bind:class="{'err': errors.nickname}" @keydown="errors.nickname=null" ref="nickname" >
            <p class="err-txt">{{errors.nickname}}</p>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_NAME_LABEL')"></th>
          <td>
            <div class="ipt-wrap">
              <input type="text" class="iptW-M" required v-model="parent.contactData.name" v-bind:class="{'err': errors.name}" @keydown="errors.name=null" ref="name">
              <span class="ipt-rule" v-html="$t('MEMBER_REQUEST_FORM_FULL_WIDTH_LABEL')"></span>
              <p class="err-txt">{{errors.name}}</p>
            </div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_FURIGANA_LABEL')"></th>
          <td>
            <div class="ipt-wrap">
              <input type="text" class="iptW-M" required v-model="parent.contactData.furigana" v-bind:class="{'err': errors.furigana}" @keydown="errors.furigana=null" ref="furigana">
              <span class="ipt-rule" v-html="$t('MEMBER_REQUEST_FORM_FULL_WIDTH_LABEL')"></span>
              <p class="err-txt">{{errors.furigana}}</p>
            </div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_POST_CODE_LABEL')"></th>
          <td>
            <div class="ipt-wrap">
              <input type="text" class="ime-dis iptW-S" :placeholder="$t('MEMBER_REQUEST_FORM_POST_CODE_PLACEHOLDER')" v-model="parent.contactData.postCode" required v-bind:class="{'err': errors.postCode}" @keydown="errors.postCode=null" ref="postCode">
              <input class="ipt-btn-gray zip-search" type="button" :value="$t('MEMBER_REQUEST_FORM_SEARCH_POST_CODE_BUTTON_LABEL')" @click="searchPostCode">
              <p class="err-txt">{{errors.postCode}}</p>
            </div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_ADDRESS_LABEL')"></th>
          <td>
            <input type="text" class="iptW-M" :placeholder="$t('MEMBER_REQUEST_FORM_ADDRESS_PLACEHOLDER')" required v-model="parent.contactData.address" v-bind:class="{'err': errors.address}" @keydown="errors.address=null" ref="address">
            <p class="err-txt">{{errors.address}}</p>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_TEL_LABEL')"></th>
          <td>
            <div class="ipt-wrap">
              <input type="text" class="ime-dis iptW-M" :placeholder="$t('MEMBER_REQUEST_FORM_PHONE_NUMBER_PLACEHOLDER')" required v-model="parent.contactData.tel" v-bind:class="{'err': errors.tel}" @keydown="errors.tel=null" ref="tel">
              <span class="ipt-rule" v-html="$t('MEMBER_REQUEST_FORM_FULL_WIDTH_NUMBERS_LABEL')"></span>
              <p class="err-txt">{{errors.tel}}</p>
            </div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_EMAIL_LABEL')"></th>
          <td>
            <div class="ipt-wrap">
              <input type="email" class="ime-dis iptW-M" required v-model="parent.contactData.email" v-bind:class="{'err': errors.email}" @keydown="errors.email=null" ref="email">
              <span class="ipt-rule" v-html="$t('MEMBER_REQUEST_FORM_FULL_WIDTH_ALPHANUMERICAL_LABEL')"></span>
              <p class="err-txt">{{errors.email}}</p>
            </div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_CONFIRM_EMAIL_LABEL')"></th>
          <td>
            <input type="email" class="ime-dis iptW-M" required v-model="parent.confirmEmail" v-bind:class="{'err': errors.confirmEmail}" @keydown="errors.confirmEmail=null" ref="confirmEmail">
            <p class="err-txt">{{errors.confirmEmail}}</p>
          </td>
        </tr>
        <tr>
          <th>{{$t('CONTACT_FORM_CONTACT_CONTENT_LABEL')}}<em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em></th>
          <td>
            <textarea v-model="parent.content" v-bind:class="{'textarea-content': true, 'err': errors.content}" @keydown="errors.content=null" ></textarea>
            <p class="err-txt">{{errors.content}}</p>
          </td>
        </tr>
        <tr>
          <th v-html="$t('CONTACT_EXPORT_FILE_LABEL')"></th>
          <td>
            <div class="ipt-file ipt-file-box" v-for="(file, index) in parent.exportFiles" :key="index">
              <label @click="parent.exportFiles.splice(index, 1)">{{$t('MEMBER_REQUEST_FORM_FILE_DELETE_BUTTON_LABEL')}}</label>
              <p class="ipt-file-txt">{{file.name}}</p>
            </div>
            <div class="ipt-file ipt-file-box" v-if="parent.exportFiles.length < 3">
              <label v-bind:class="{'err': errors.exportFiles}" @click="errors.exportFiles=null"  ref="exportFiles">
                <input type="file" required @change="addExportFile">{{$t('MEMBER_REQUEST_FORM_FILE_SELECT_BUTTON_LABEL')}}
              </label>
              <p class="ipt-file-txt" v-html="$t('MEMBER_REQUEST_FORM_FILE_UNSELECTED_MESSAGE')"></p>
              <p class="err-txt">{{errors.exportFiles}}</p>
            </div>
          </td>
        </tr>
        <tr class="att-use">
          <th>&nbsp;</th>
          <td>
            <div class="file-up-att" v-html="$t('MEMBER_REQUEST_FORM_FILE_UPLOAD_CAUTION_MESSAGE')"></div>
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_AGREE_LABEL')"></th>
          <td>
            <label for="rule-chk">
              <input type="checkbox" id="rule-chk" class="checkbox-input" required>
              <span class="checkbox-parts" v-html="$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_LABEL')"></span>
            </label>
          </td>
        </tr>
        <tr class="att-use">
          <th>&nbsp;</th>
          <td>
            <p class="privacy-link">
              {{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE1')}}
              <a @click="$routerGoNewWindow($define.PAGE_NAMES.PRIVACY_PAGE_NAME, null, {lang: $i18n.locale})">{{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE2')}}</a>
              {{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE3')}}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="btn-form">
      <input type="button" id="sbm-login" :value="$t('MEMBER_REQUEST_FORM_SUBMIT_LABEL')" disabled="disabled" @click="validate">
    </div>
  </form>
</section>
</template>

<script>
import Methods from '@/api/methods'
import UploadFile from '@/api/uploadFile'
import RegisterLogic from '../RegisterMember/RegisterLogic.js'
export default {
  props : {
    parent : {
      type    : Object,
      default : Object
    }
  },
  data() {
    return {
      scripts : ['login.js'],
      errors  : []
    }
  },
  mixins  : [RegisterLogic],
  methods : {
    getContactConstants() {
      this.$store.state.loading = true
      Methods.apiExcute('public/get-contact-constants', this.$i18n.locale).then(data => {
        this.$store.state.loading = false
        this.parent.constants = data.constants
        this.parent.memberId = data.memberId
        if (data.member) {
          this.parent.contactData = Object.assign({}, data.member, this.parent.contactData)
        }
      })
        .catch(error => {
          this.$store.state.loading = false
          this.errors = Methods.parseHtmlResponseError(this.$router, error)
        })
    },
    searchPostCode() {
      const params = {
        postCode : this.parent.contactData.postCode
      }
      this.$store.state.loading = true
      Methods.apiExcute('search-post-code', this.$i18n.locale, params).then(data => {
        this.$store.state.loading = false
        this.parent.contactData.address = data.address1 + data.address2 + data.address3
        this.parent.contactData = Object.assign({}, this.parent.contactData)
      })
        .catch(error => {
          this.$store.state.loading = false
          this.errors = Methods.parseHtmlResponseError(this.$router, error)
        })
    },
    addExportFile(file) {
      if (file.target.files.length > 0) {
        if (this.checkFileSize(file.target.files[0])) {
          this.errors = Object.assign({}, this.errors, {exportFiles : this.checkFileSize(file.target.files[0])})
        } else {
          this.parent.exportFiles.push(file.target.files[0])
        }
      }
    },
    checkInputFormat() {
      const tags = [
        'address',
        'companyName',
        'name'
      ]
      const pattern = new RegExp('^[0-9a-zA-Z -/:-@\[-~]+$')
      const jpPattern = new RegExp('^([^\x01-\x7E]|[0-9a-zA-Z -/:-@\[-~])+$')
      this.errors = {}
      for (const tag of tags) {
        if (this.parent.contactData[tag]) {
          if (this.parent.selectedCountry && this.parent.selectedCountry.value1 === 'JP' && !jpPattern.test(this.parent.contactData[tag])) {
            this.errors[tag] = this.$t('TEXT_FORMAT_ERROR')
          } else if (this.parent.selectedCountry.value1 !== 'JP' && !pattern.test(this.parent.contactData[tag])) {
            this.errors[tag] = this.$t('TEXT_FORMAT_ERROR')
          }
        }
      }
      if (this.parent.contactData.email !== this.parent.confirmEmail) {
        this.errors.confirmEmail = this.$t('MAIL_CONFIRM_ERROR_MESSAGE')
      }
    },
    validate() {
      const params = {
        inquiryData  : this.parent.contactData,
        content      : this.parent.content,
        validateFlag : true
      }
      this.errors = {}
      this.checkInputFormat()
      this.$store.state.loading = true
      Methods.apiExcute('public/request-inquiry', this.$i18n.locale, params).then(data => {
        if (Object.keys(this.errors).length === 0) {
          this.uploadFiles()
            .then(() => {
              this.$store.state.loading = false
              this.parent.editFlag = false
              window.scrollTo({
                top      : 0,
                left     : 0,
                behavior : 'smooth'
              })
            })
            .catch(error => {
              this.$store.state.loading = false
              console.log('アップロード失敗', error)
            })
        } else {
          this.$store.state.loading = false
        }
      })
        .catch(error => {
          console.log('error', error)
          this.$store.state.loading = false
          this.errors = Object.assign(Methods.parseHtmlResponseError(this.$router, error), this.errors)
        })
    },
    uploadFiles() {
      if (this.parent.exportFiles.filter(file => !file.key).length === 0) {
        return Promise.resolve()
      }
      return Promise.resolve()
        .then(() => {
          return UploadFile.getUploadCredentials('inquiry')
        })
        .then(credentials => {
          return Promise.all(this.parent.exportFiles.filter(file => !file.key).map(file => {
            return UploadFile.upload(credentials, file)
              .then(result => {
                file.key = result.Key
                return Promise.resolve(result.Key)
              })
          }))
        })
    }
  },
  mounted() {
    Methods.addExternalScripts(this.scripts)
  },
  created() {
    this.getContactConstants()
  },
  watch : {
    '$i18n.locale'() {
      this.getContactConstants()
    },
    'parent.contactData.countryCode'(value) {
      this.parent.selectedCountry = this.parent.constants.find(constant => constant.key_string === 'COUNTRY_CODE' && constant.value1 === value)
    },
    errors(value) {
      const keys = Object.keys(value)
      if (keys.length > 0 && this.$refs[keys[0]]) {
        this.$refs[keys[0]].focus()
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .ipt-file-box {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 768px) {
    p.err-txt {
      position: absolute;
      top: 50%;
      left: 450px;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      width: 100%;
      max-width: 290px;
    }
    .textarea-content {
      background-color: white;
      width:430px !important;
    }
  }
  @media only screen and (max-width: 767px) {
    p.err-txt {
        position: static;
        -webkit-transform: none;
        transform: none;
        max-width: 100%;
        margin-top: 5px;
    }
  }

  .with-int-no {
    width: 305px !important;
  }
  select.err {
    background-color: #fffafa !important;
    border: solid 1px #f00 !important;
  }
  label.err {
    background-color: #fffafa !important;
    border: solid 1px #f00 !important;
  }
  .bold-text {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
  }
</style>
